import React, { Fragment } from 'react';
import { ToolTip as ImportToolTip } from '@trp-beacon-ui-kit/react-communication';
import './LegacyToolTip.scss';
import Disclosure from '../Disclosure/Disclosure';

export const PopUpPosition = {
  TOP: 'top',
  BOTTOM: 'bottom'
};

let toolTipCounter = 0;
const ToolTipDescription = ({ header, children }) => (
  <div>
    <span className="tooltip-header">{header}</span>
    <span className="tooltip-body">{children}</span>
  </div>
);

const LegacyToolTip = ({
  callerText,
  header,
  message,
  popOutPlacement,
  maxNoteWidth
}) => {
  const toolTipNumber = ++toolTipCounter;
  const callerNode = <span className="trigger-text">{callerText}</span>;
  return (
    <Fragment>
      <ImportToolTip
        callerNode={callerNode}
        maxNoteWidth={maxNoteWidth}
        popOutPlacement={popOutPlacement}
        description={
          <ToolTipDescription header={header}>
            <Disclosure content={message} />
          </ToolTipDescription>
        }
        id={toolTipNumber.toString()}
      />
    </Fragment>
  );
};

export default LegacyToolTip;
